import project01 from "./../img/projects/horizonSmall.jpg";
import project01Big from "./../img/projects/horizonBig.jpg";

import project02 from "./../img/projects/krwz_filmsSmall.jpg";
import project02Big from "./../img/projects/krwz_filmsBig.jpg";

import project03 from "./../img/projects/krwz_accountsSmall.jpg";
import project03Big from "./../img/projects/krwz_accountsBig.jpg";

import project04 from "./../img/projects/04.jpg";
import project04Big from "./../img/projects/04-big.jpg";

import project05 from "./../img/projects/05.jpg";
import project05Big from "./../img/projects/05-big.jpg";

import project06 from "./../img/projects/06.jpg";
import project06Big from "./../img/projects/06-big.jpg";



const projects = [
	{
		title: 'Build store',
		skills: 'Python, jQuery, SQLlite',
		img: project01,
		imgBig: project01Big,
		gitHubLink: 'https://github.com/Yury08/Build_store',
	},
	{
		title: 'Online Cinema',
		skills: 'Django, JS, Redis, MySql, Celery',
		img: project02,
		imgBig: project02Big,
		gitHubLink: 'https://github.com/Yury08/Krwz_films',
	},
	{
		title: 'Marketplace',
		skills: 'Python, MySql, RestFramework',
		img: project03,
		imgBig: project03Big,
		gitHubLink: 'https://github.com/Yury08/Krwz_accounts',
	},
	// {
	// 	title: 'Dating app',
	// 	skills: 'React, Node.js, MongoDB',
	// 	img: project04,
	// 	imgBig: project04Big,
	// 	gitHubLink: 'https://github.com/Yury08',
	// },
	// {
	// 	title: 'Landing',
	// 	skills: 'React, Node.js, MongoDB',
	// 	img: project05,
	// 	imgBig: project05Big,
	// 	gitHubLink: 'https://github.com/Yury08',
	// },
	// {
	// 	title: 'Gaming community',
	// 	skills: 'React, Node.js, MongoDB',
	// 	img: project06,
	// 	imgBig: project06Big,
	// 	gitHubLink: 'https://github.com/Yury08',
	// },
];

export { projects }